import { ArcElement, Chart as ChartJS, Legend, Tooltip } from 'chart.js';
import ChartDataLabels from 'chartjs-plugin-datalabels';
import React from 'react';
import { Doughnut } from 'react-chartjs-2';

ChartJS.register(ArcElement, Tooltip, Legend);

const DoughnutChart = ({
  data,
  value,
  feedbackValues,
  headingRequired = false,
  valueRequired = false,
  show = false,
  left = 0,
  right = 0,
  showUserCounts = false,
}) => {
  const options = {
    responsive: true,
    cutout: '70%',
    plugins: {
      legend: {
        position: 'top',
        display: false,
      },
      title: {
        display: false,
      },
      tooltip: {
        enabled: true,
        displayColors: false,
        caretSize: 8,
        backgroundColor: '#1E242C',
        padding: {
          x: 15,
          y: 10,
        },
        callbacks: {
          label: function (tooltipItem) {
            const dataset = tooltipItem.dataset;
            const dataIndex = tooltipItem.dataIndex;
            const feedback = dataset.data[dataIndex];
            const userCount = dataset.userCounts ? dataset.userCounts[dataIndex] : 0;
            return showUserCounts ? `${userCount}` : `${feedback}`;
          },
        },
      },
      datalabels: {
        display: show,
        anchor: 'end',
        align: 'end',
        offset: 0,
        font: {
          size: 14,
        },
        color: '#000',
        formatter: (value, context) => {
          const index = context.dataIndex;
          return feedbackValues[index];
        },
      },
    },
    layout: {
      padding: {
        left: left,
        right: right,
      },
    },
  };

  return (
    <div className="h-[200px] relative flex justify-center">
      <Doughnut data={data} options={options} plugins={[ChartDataLabels]} />
      <p className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 text-[16px] font-bold text-center w-[70%] h-[70%] flex justify-center items-center flex-col gap-[5px]">
        {headingRequired && (
          <span className="text-[#667488] text-center font-base text-[13px]">
            Modal <br />
            Success Score
          </span>
        )}
        {valueRequired && value + '%'}
      </p>
    </div>
  );
};
export default DoughnutChart;
